import { render, staticRenderFns } from "./SoliSearchButton.vue?vue&type=template&id=53bde183&scoped=true"
import script from "./SoliSearchButton.vue?vue&type=script&lang=js"
export * from "./SoliSearchButton.vue?vue&type=script&lang=js"
import style0 from "./SoliSearchButton.vue?vue&type=style&index=0&id=53bde183&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bde183",
  null
  
)

export default component.exports